import URLPattern from 'url-pattern';
import { AxiosInstance } from 'axios';
import { messageContents } from '../../constants/message';
import { openMessageModal } from '../../utils/message';

const interceptedRoutes = [
  new URLPattern('/signup/'),
  new URLPattern('/signup/complete'),
  new URLPattern('/signup/companies/(:companyId)/userInvitations'),
  new URLPattern('/signup/complete-invite'),
];

const networkErrorInterceptor = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      // Don't intercept cancelled requests
      if (error.code === 'ERR_CANCELED') {
        return Promise.reject(error);
      }

      const isMatchingRoute = interceptedRoutes.some((endpoint) => {
        return error.config?.url && endpoint.match(error.config.url);
      });

      if (!error?.response && isMatchingRoute) {
        openMessageModal(messageContents.networkError);
      }

      return Promise.reject(error);
    },
  );

  return axiosInstance;
};

export default networkErrorInterceptor;
